import React from 'react';
import styles from './styles.module.scss';

type TituloSeccionProps = {
    children?: React.ReactNode
    fontSize?: string
    align?: React.CSSProperties['textAlign']
    color?: string
    [key: string]: any
}

const TituloSeccion = ({ children, fontSize, align, color, ...rest }: TituloSeccionProps) => {
  return (
    <h1
      {...rest}
      className={styles.titulo}
      style={{ fontSize: fontSize ?? '1.4rem', textAlign: align ?? 'left', color: color ?? 'inherit' }}
    >
      {children}
    </h1>
  );
};

export default TituloSeccion;
